
import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
const globalValues = namespace('globalValues')

@Component
export default class Notification extends Vue {
  @globalValues.State
  public notificationMessage!: string

  @globalValues.Action
  public setNotification!: (message?: string) => void

  @Watch('notificationMessage')
  notificationMessageChanged (newMessage: string) {
    if (newMessage !== undefined) {
      setTimeout(() => {
        this.setNotification(undefined)
        this.removeClickAnywehre()
      }, 10000)

      document.documentElement.addEventListener('click', this.clickAnywhere, true)
    }
  }

  private clickAnywhere () {
    this.setNotification(undefined)
    this.removeClickAnywehre()
  }

  private removeClickAnywehre () {
    document.documentElement.removeEventListener('click', this.clickAnywhere, true)
  }
}
